import MoviePage from './MoviePage';

export default MoviePage;
